import { render, staticRenderFns } from "./drawer-role.vue?vue&type=template&id=59808462&scoped=true&"
import script from "./drawer-role.vue?vue&type=script&lang=js&"
export * from "./drawer-role.vue?vue&type=script&lang=js&"
import style0 from "./drawer-role.vue?vue&type=style&index=0&id=59808462&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59808462",
  null
  
)

export default component.exports